import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
  ViewContainerRef
} from '@angular/core';
import {
  WorkshopJobEventBase,
  WorkshopJobEventType,
  validateEventEdit
} from '../../../models/workshop-job-event';
import { ConfigService } from '../../../shared/services/config.service';
import { ViewWorkshopJobStoreService } from '../view-workshop-job-store.service';
import { map } from 'rxjs/operators';
import { WORKSHOP } from '../../../../testIds';
import { WorkshopJobEventLabelPipe } from '../workshop-job-event-label.pipe';
import { MomentModule } from 'ngx-moment';
import { HlCurrencyPipe } from '../../../shared/pipes/hl-currency.pipe';
import { UserIdToNamePipe } from '../../../shared/pipes/user-id-to-name.pipe';
import { KeyValuePairComponent } from '../../../shared/general/key-value-pair/key-value-pair.component';
import { NgSwitch, NgSwitchCase, NgIf, AsyncPipe } from '@angular/common';
import { TestIdDirective } from '../../../shared/directives/test-id.directive';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AssessmentDialogComponent } from '../event-dialogs/assessment-dialog/assessment-dialog.component';
import { QuotationDialogComponent } from '../event-dialogs/quotation-dialog/quotation-dialog.component';
import { QuoteApprovedComponent } from '../event-dialogs/quote-approved/quote-approved.component';
import { WaitingForPartsDialogComponent } from '../event-dialogs/waiting-for-parts/waiting-for-parts-dialog.component';
import { RepairStartedDialogComponent } from '../event-dialogs/repair-started/repair-started-dialog.component';
import { CompletedDialogComponent } from '../event-dialogs/completed/completed-dialog.component';
import { CancelDialogComponent } from '../event-dialogs/cancelled/cancel-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-workshop-job-event',
  templateUrl: './workshop-job-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatCard,
    TestIdDirective,
    MatCardContent,
    NgSwitch,
    NgSwitchCase,
    KeyValuePairComponent,
    NgIf,
    AsyncPipe,
    UserIdToNamePipe,
    HlCurrencyPipe,
    MomentModule,
    WorkshopJobEventLabelPipe,
    MatIconButton,
    MatIcon,
    MatButton
  ]
})
export class WorkshopJobEventComponent {
  testIds = WORKSHOP;
  @Input() event: WorkshopJobEventBase<any>;
  @Output() editEvent = new EventEmitter<WorkshopJobEventBase<any>>();

  currency = this.configService.userConfig.pipe(
    map((config) => config?.currency ?? 'GBP')
  );

  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private vcr: ViewContainerRef,
    private store: ViewWorkshopJobStoreService
  ) {}

  onEditClick() {
    const eventEditDialog = this.getEventEditDialog(this.event.type);
    if (eventEditDialog) {
      this.dialog.open(eventEditDialog, {
        viewContainerRef: this.vcr,
        minWidth: '50vw',
        data: {
          eventToEdit: this.event
        }
      });
    }
  }

  private getEventEditDialog(type: WorkshopJobEventType): ComponentType<any> {
    switch (type) {
      case 'assessment':
        return AssessmentDialogComponent;
      case 'quotation':
        return QuotationDialogComponent;
      case 'quote_approved':
        return QuoteApprovedComponent;
      case 'waiting_for_parts':
        return WaitingForPartsDialogComponent;
      case 'repair_started':
        return RepairStartedDialogComponent;
      case 'completed':
        return CompletedDialogComponent;
      case 'cancelled':
        return CancelDialogComponent;
    }
  }
}
